import { render } from "./SingleSelect.vue?vue&type=template&id=9b1809b2"
import script from "./SingleSelect.vue?vue&type=script&lang=ts"
export * from "./SingleSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script